import {connect, MapDispatchToPropsObject} from 'react-redux';
import {VideoSettingsContainer as Container, IVideoSettingsContainerProps} from './container';
import {
  saveVideoSettings,
  selectMediaInput,
  setVideoQuality,
  loadMedia,
} from '../../redux/modules/video-settings';

const mapStateToProps = ({videoSettings: state}): IVideoSettingsContainerProps => ({
  audioOutputDeviceId: state.audioOutput.deviceId || state.audioOutputDeviceId,
  audioInputDeviceId: state.audioInput.deviceId || state.audioInputDeviceId,
  videoInputDeviceId: state.videoInput.deviceId || state.videoInputDeviceId,
  audioInputDevices: state.audioInputDevices,
  videoInputDevices: state.videoInputDevices,
  videoQualityError: state.videoQuality.error,
  audioInputError: state.audioInput.error,
  videoInputError: state.videoInput.error,
  videoQualityId: state.videoQuality.value || state.videoQualityId,
  screenType: state.screenType,
  isLoading: state.isLoading,
  stream: state.stream,
  error: state.error,
});

const mapDispatchToProps: MapDispatchToPropsObject = {
  saveVideoSettings,
  selectMediaInput,
  setVideoQuality,
  loadMedia,
};

export const VideoSettings = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
